import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-12 px-0 my-4" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "title-4 text-grey-800 mb-2"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "d-flex justify-content-center"
}
const _hoisted_6 = { class: "link-default" }
const _hoisted_7 = {
  key: 0,
  class: "close-icon"
}
const _hoisted_8 = {
  key: 1,
  class: "close-icon"
}

import {
	ref,
	Ref,
	nextTick,
	watch,
	onMounted,
	computed,
	ComputedRef,
} from "vue"
//import store from "@/vue/planning/store/store"
import PrestationComp from "@/vue/planning/components/result/prestation.vue"
import OopsBanner from "@/vue/planning/components/oopsBanner.vue"
import OopsBanner2 from "@/vue/planning/components/oopsBanner2.vue"
import {
	defaultNumberOfPrestationsToShow_Desktop,
	additionalNumberOfPrestationsToShow_Desktop,
	defaultNumberOfPrestationsToShow_Mobile,
	additionalNumberOfPrestationsToShow_Mobile,
} from "@/config/plannerConfig"
import BlueBtn from "@/vue/common/BlueBtn.vue"
import { checkIfCompanyIsCgosException } from "@/utils/utils"

// Get cookies1`
import { checkIfCompanyIsCgos, getCookie } from "@/utils/utils"

// types
import { Prestation } from "@/types/index"
import type { WiypPrestation } from "@/types/responses"

// computed
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes"

// Tracking
import trackViewItem from "@/tracking/trackItems"

import { useStore } from "vuex"
import getWiypData from "@/vue/planning/computed/getWiypData"

export default /*@__PURE__*/_defineComponent({
  __name: 'result',
  setup(__props) {

const store = useStore();

// refs
const prestationsList = ref()
const isAnimating: Ref<boolean> = ref(false)
const queue: Ref<Array<any>> = ref([])
const prestations: Ref<Array<Prestation>> = ref([])
const readyPrestations: Ref<Array<Prestation>> = ref([])
const additionalPrestationsNum: Ref<number> = ref(0)

// computed
const activePrestations: ComputedRef<Array<string> | null> = computed(() => store.state.activePrestations)
const prestFromCatalog: ComputedRef<Array<Prestation> | null> = computed(() => store.state.prestationsFromCatalog)

const defaultNumberOfPrestationsToShow = computed(() => {
	if (store.state.screenType === "mobile") {
		return defaultNumberOfPrestationsToShow_Mobile
	}

	return defaultNumberOfPrestationsToShow_Desktop
})
const additionalNumberOfPrestationsToShow = computed(() => {
	if (store.state.screenType === "mobile") {
		return additionalNumberOfPrestationsToShow_Mobile
	}
	return additionalNumberOfPrestationsToShow_Desktop
})
const stepNum = computed(() => {
	if (
		availableTransportPackCodes.value.length > 0 &&
		store.state.screenType === "desktop"
	)
		return "3. "
	return "2. "
})
const prestationsToShow: ComputedRef<Array<Prestation>> = computed(() => {
	let result: Array<Prestation> = []

	if (store.getters.locale === "fr_FR_CSE" && checkIfCompanyIsCgos()) {

		if (checkIfCompanyIsCgosException()) {
			result = prestations.value.filter(prestation => {
				if (!prestation.capacityMin || prestation.capacityMin > (store.state.participants || []).length) {
					return false;
				}
				return prestation;
			});
		}
		else {

			const prestationsWithCapacityLimitation = prestations.value.filter(
				(prestation) => prestation.capacity <= 8
			)

			result = prestationsWithCapacityLimitation.slice(
				0,
				defaultNumberOfPrestationsToShow.value + additionalPrestationsNum.value
			)
		}

	} else {
		result = prestations.value.slice(
			0,
			defaultNumberOfPrestationsToShow.value + additionalPrestationsNum.value
		)
	}

	if (prestFromCatalog.value) {
		result = prestFromCatalog.value
	}

	return result
})

const isShowingAllPrestations = computed(() => {
	return (
		store.getters.prestations.length <
		defaultNumberOfPrestationsToShow.value + additionalPrestationsNum.value
	)
})

// methods
const scrollToPlannerStart = () => {
	window.dispatchEvent(
		new CustomEvent("smoothScrollToSelector", {
			detail: {
				selector: "#tf-planning",
			},
		})
	)
}

const getEmptyPrestations = (): Array<Prestation> => {
	// controls the number of placeholders to show during loading
	if (store.state.screenType === "mobile") {
		return []
	} else if (store.state.screenType === "tablet") {
		return [{}]
	} else {
		return [{}, {}, {}]
	}
}

const updateAnimations = (): void => {
	// Exit early if animations were cancelled
	if (!isAnimating.value) {
		return
	}

	if (queue.value.length === 0) {
		isAnimating.value = false
		return
	}

	const newPrestations = queue.value.shift() // pops object from beginning of array
	queue.value = [...queue.value]

	if (
		prestations.value.length === 0 ||
		Object.keys(prestations.value[0]).length === 0
	) {
		if (
			newPrestations.length === 0 ||
			Object.keys(newPrestations[0]).length === 0
		) {
			updateAnimations()
			return
		}
	}

	if (prestationsList.value) {
		prestationsList.value.style.opacity = 0
	}

	setTimeout(() => {
		// Check again if animations were cancelled during the timeout
		if (!isAnimating.value) {
			return
		}

		if (store.getters.locale === "fr_FR_CSE" && checkIfCompanyIsCgos()) {
			// FIXME this is horrible, who did this?!
			const maxCapacity = parseInt(getCookie("maxCapacity") ?? "8")
			const filteredPrestations = newPrestations.filter(
				(prestation: Prestation) => {
					if (prestation.maxCapacity) {
						return prestation.maxCapacity <= maxCapacity
					} else if (prestation.capacity) {
						return prestation.capacity <= maxCapacity
					} else {
						return true
					}
				}
			)
			//prestations.value = [...filteredPrestations];
			updatePrestations(filteredPrestations)
		} else {
			//prestations.value = [...newPrestations]
			updatePrestations(newPrestations)
		}

		if (prestationsList.value) {
			prestationsList.value.style.opacity = 1
		}
		setTimeout(() => {
			// Check again before recursing
			if (!isAnimating.value) {
				return
			}
			updateAnimations()
			return
		}, 100)
	}, 100)
}

const triggerUpdateAnimations = (): void => {
	if (isAnimating.value) return

	isAnimating.value = true
	updateAnimations()
	store.state.prestationsLoaded = true
}

const setIntersectionObserver = (): void => {
	const options = {
		root: null,
		threshold: 0.5,
	}
	const callback = (entries: any) => {
		entries.forEach((entry: any) => {
			if (entry.isIntersecting) {
				if (!store.state.scrolledToPlanning && store.state.prestationsLoaded) {
					trackViewItem(
						store.getters.prestations,
						"view_item",
						store.state.packCode,
						store.state.averageRatingPerLihe,
						store.state.reviewNumberPerLihe,
						store.getters.cheapestPrestationIndex
					)
				}
				if (store.state.prestationsLoaded) {
					store.state.scrolledToPlanning = true
				}
			}
		})
	}
	const observer = new IntersectionObserver(callback, options)
	const target = document.querySelector("#tf-planning")
	if (target) {
		observer.observe(target)
	}
}

const handleSeeMorePrestationsClick = () => {
	if (isShowingAllPrestations.value) {
		additionalPrestationsNum.value = 0
		scrollToPlannerStart()
	} else {
		additionalPrestationsNum.value += additionalNumberOfPrestationsToShow.value
	}
}

const updatePrestations = (newPrestations: Array<Prestation>) => {
	prestations.value = newPrestations.filter((prestation) => {
		if (!store.state.packageId) return false;
		if (store.state.packCode === "HS") {
			return true;
		}
		const wiypCall = getWiypData.value(store.state.packageId);
		return wiypCall?.wiypPrices?.some(
			(w: WiypPrestation) => w.prestId === prestation.prestationId
		) ?? false;
	});	
}

watch(
	() => store.getters.prestations,
	(newPrestations: Array<Prestation>) => {
		const isPackage = store.state.packCode && store.state.packCode !== "HS"

		// If the prices endpoint was not called yet and it's a package, return
		if (isPackage && !store.state.calledPrice) return

		const nextPrestations =
			newPrestations.length > 0 ? newPrestations : getEmptyPrestations()

		// We only want the "blinking" skeleton transition when a full
		// availability search is running (state.loading is true).
		// For price-only/WIYP updates (loading is false), update prestations
		// directly without going through the animated queue to avoid blinking.
		if (store.state.loading) {
			queue.value = [...queue.value, nextPrestations]
		} else {
			updatePrestations(nextPrestations)
		}

		if (newPrestations && newPrestations.length) {
			trackViewItem(
				newPrestations,
				"view_item",
				store.state.packCode,
				store.state.averageRatingPerLihe,
				store.state.reviewNumberPerLihe,
				store.getters.cheapestPrestationIndex
			)
		}
	}
)

watch(
	() => store.state.loading,
	(newVal: boolean, oldVal: boolean) => {
		if (newVal && !oldVal) {
			queue.value = [...queue.value, getEmptyPrestations()]
		} else if (!newVal && oldVal) {
			// Availability search just finished.
			// Ensure we clear any remaining skeleton queue and show the latest prestations.
			const latestPrestations = store.getters.prestations as Array<Prestation>
			const nextPrestations =
				latestPrestations.length > 0 ? latestPrestations : getEmptyPrestations()

			// Stop animations and clear queued skeletons
			isAnimating.value = false
			queue.value = []

			// Ensure opacity is reset immediately to prevent skeleton from staying
			if (prestationsList.value) {
				prestationsList.value.style.opacity = 1
			}

			// Render the final prestations without additional blinking
			// prestations.value = [...nextPrestations]
			readyPrestations.value = [...nextPrestations]
		}
	}
)

watch(
	() => [getWiypData.value(store.state.packageId), readyPrestations.value],
	() => {
		if (readyPrestations.value.length === 0 || !getWiypData.value(store.state.packageId)?.wiypPrices) return;
		updatePrestations(readyPrestations.value)		
	}
)


watch(
	() => queue.value,
	() => {
		nextTick(triggerUpdateAnimations)
		// Will fire the dispatch for refreshDataStoredOnWindow, the listener is on documentReady
		window.dispatchEvent(new Event("refreshDataStoredOnWindow"))
	}
)

onMounted(() => {
	prestations.value = getEmptyPrestations()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(store).state.loading && prestations.value.length === 0)
      ? (_openBlock(), _createBlock(OopsBanner2, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (prestations.value.length > 0 && prestationsToShow.value.length > 0 && !activePrestations.value)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(stepNum.value) + _toDisplayString(_unref(store).state.content.planner_prestationsTitle), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "prestations-list",
            style: {"display":"block","opacity":"1"},
            ref_key: "prestationsList",
            ref: prestationsList
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prestationsToShow.value, (prestation, prestation_i) => {
              return (_openBlock(), _createBlock(PrestationComp, {
                key: prestation.id || prestation_i,
                ref_for: true,
                ref: "prestation",
                prestation: prestation
              }, null, 8, ["prestation"]))
            }), 128))
          ], 512),
          (prestationsToShow.value.length === 0 && _unref(checkIfCompanyIsCgosException)())
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(OopsBanner)
              ]))
            : _createCommentVNode("", true),
          (!activePrestations.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (prestations.value.length > defaultNumberOfPrestationsToShow.value)
                  ? (_openBlock(), _createBlock(BlueBtn, {
                      key: 0,
                      onClick: handleSeeMorePrestationsClick
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(!isShowingAllPrestations.value
								? _unref(store).state.content.planner_seeMoreHebergements
								: _unref(store).state.content.liheDesc_seeLess), 1),
                        (!isShowingAllPrestations.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[0] || (_cache[0] = [
                              _createElementVNode("svg", {
                                width: "14",
                                height: "14",
                                class: "icon"
                              }, [
                                _createElementVNode("use", { "xlink:href": "#___icon___chevron-down-bold" })
                              ], -1)
                            ])))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, _cache[1] || (_cache[1] = [
                              _createElementVNode("svg", {
                                width: "14",
                                height: "14",
                                class: "icon"
                              }, [
                                _createElementVNode("use", { "xlink:href": "#___icon___chevron-up-bold" })
                              ], -1)
                            ])))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})